"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoCodeListsService = void 0;
class PromoCodeListsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns a list of promo code lists.
     * @param advertiserId
     * @param q
     * @param page
     * @param count
     * @returns PromoCodeListsResponse
     * @throws ApiError
     */
    getPromoCodeLists(advertiserId, q, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/promocodelists',
            query: {
                'advertiserId': advertiserId,
                'q': q,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Create a promoCodeList
     * @param requestBody
     * @returns PromoCodeListResponse
     * @throws ApiError
     */
    createPromoCodeList(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/promocodelists',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns a specific promoCodeList by id.
     * @param id
     * @returns PromoCodeListResponse
     * @throws ApiError
     */
    getPromoCodeList(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/promocodelists/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update a promoCodeList
     * @param id
     * @param requestBody
     * @returns PromoCodeListResponse
     * @throws ApiError
     */
    updatePromoCodeList(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/promocodelists/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a promoCodeList
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deletePromoCodeList(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/promocodelists/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Upload multiple promoCodes to a list
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    bulkInsertPromoCodes(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/promocodelists/{id}/bulk-insert-codes',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.PromoCodeListsService = PromoCodeListsService;
